import toast from 'react-hot-toast';

export const copyLinkToClipboard = (link) => {
    navigator.clipboard.writeText(link);
    toast.success('Link copied to clipboard');
};
